import { readGuide } from "@/mocks/events";
import { SectionHeading } from "@/components/base/Shared";
import Reveal from "@/components/base/Reveal";

export default function ReadGuide() {
  return (
    <section id="guide" className="bg-background-100 border-y border-background-200 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-5">
            <SectionHeading
              eyebrow="HOW TO READ"
              title="传播解读：看懂热度走势的四个抓手"
              desc="热度榜单只给结果，真正有价值的是判断过程。以下四点是我们整理每条事件时反复使用的观察角度。"
            />
            <div className="rounded-2xl bg-background-50 border border-background-200 p-6">
              <p className="text-sm text-foreground-600 leading-relaxed">
                <strong className="text-foreground-900 font-normal">小提示：</strong>
                同一张热度曲线，横轴换成「首爆后小时数」会比按自然时间更直观，因为不同事件的爆发时段并不相同。
                本站所有曲线都基于首爆时间对齐。
              </p>
            </div>
          </div>

          <div className="lg:col-span-7 flex flex-col gap-4">
            {readGuide.map((item, index) => (
              <Reveal key={item.title} delay={index * 80}>
                <article className="flex items-start gap-5 rounded-2xl bg-background-50 border border-background-200 p-5 md:p-6">
                  <span className="w-12 h-12 shrink-0 rounded-xl bg-primary-50 text-primary-600 flex items-center justify-center">
                    <i className={`${item.icon} text-xl`} />
                  </span>
                  <div>
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}